import React, { useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { TbChevronRight } from "react-icons/tb";

import moment from "moment";
import "moment/locale/es";
import { useSelector } from "react-redux";
moment.locale("es");

const appointments = [
  { id: 1, date: "Junio 09", time: "1:00 PM" },
  { id: 2, date: "Junio 09", time: "2:30 PM" },
  { id: 3, date: "Junio 09", time: "3:00 PM" },
  { id: 4, date: "Junio 10", time: "9:00 AM" },
  { id: 5, date: "Junio 10", time: "10:30 AM" },
  { id: 6, date: "Junio 10", time: "10:30 AM" },
];

const AppointmentStep = ({
  selectedDate,
  selectedTime,
  availableHours = [],
  onDateSelect,
  onTimeSelect,
  onJoinQueue,
  onNextStep,
}) => {
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [isSectionExpanded, setIsSectionExpanded] = useState(false);

  const isPastTime = (timeString) => {
    if (!selectedDate) return false;

    const [hours, minutes] = timeString.split(":");
    const appointmentTime = new Date(selectedDate);
    appointmentTime.setHours(parseInt(hours), parseInt(minutes));

    return appointmentTime < new Date();
  };

  const handleAppointmentSelect = (appointment) => {
    setSelectedAppointment(appointment);
  };

  const toggleSection = () => {
    setIsSectionExpanded(!isSectionExpanded);
  };

  const renderAvailableHours = () => {
    const filtered = availableHours.filter((h) => h.disponible);

    if (!filtered.length) {
      return (
        <p className="no-hours">No hay horarios disponibles para esta fecha.</p>
      );
    }

    return (
      <div className="hours-list">
        {filtered.map(({ inicio, fin }, idx) => {
          const disabled = isPastTime(inicio);
          const isSelected = selectedTime === inicio;

          return (
            <button
              key={idx}
              className={` ${theme === 'dark' ? 'hour-button-dark' : 'hour-button'} ${isSelected ? "selected" : ""}`}
              onClick={() => onTimeSelect(inicio)}
              disabled={disabled}
            >
              {inicio} - {fin}
            </button>
          );
        })}
      </div>
    );
  };

  const theme = useSelector((state) => state.theme.theme) || "light";

  return (
    <div className="step-content_">
      <div>
        <h2 className="step-title">Selecciona el día y la hora de tu cita</h2>
      </div>

      <div className="calendar-section">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr .6fr",
            gap: "1rem",
            position: "relative",
          }}
        >
          <div
            style={{
              backgroundColor: theme === "dark" ? "#ede3bb" : "#fffbeb",
            }}
            className="queue-section"
          >
            <div className="queue-info">
              <h3 style={{ color: "#92400e" }}>
                ¿Necesitas atención más rápida?
              </h3>
              <p>
                Ingresa a nuestra cola de espera y te contactaremos si hay
                alguna cancelación
              </p>
              <button className="queue-btn" onClick={onJoinQueue}>
                Ingresar a cola de espera
              </button>
            </div>
          </div>
          <div
            className={`section card_background ${
              isSectionExpanded ? "expanded" : ""
            }`}
            style={{}}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr auto",
                alignItems: "center",
              }}
            >
              <h3 className="section-title">
                <span className="section-icon"></span> Citas disponibles que te
                podrían interesar.
              </h3>
              <button className="ver_mas_citas" onClick={toggleSection}>
                {isSectionExpanded ? "Ver menos" : "Ver más"}
              </button>
            </div>
            <div className="appointments-grid">
              {appointments.map((app) => (
                <div
                  key={app.id}
                  className={`appointment-card ${
                    selectedAppointment?.id === app.id ? "selected" : ""
                  }`}
                  style={{
                    backgroundColor:
                      selectedAppointment?.id === app.id && theme === "dark"
                        ? "#f0f8ff00"
                        : selectedAppointment?.id === app.id &&
                          theme === "light"
                        ? "#f0f8ff"
                        : "",
                    border:
                      selectedAppointment?.id === app.id && theme === "dark"
                        ? "1px solid #3b82f6"
                        : selectedAppointment?.id === app.id &&
                          theme === "light"
                        ? "1px solid #3b82f6"
                        : "1px solid #e9ebec99",
                  }}
                  onClick={() => handleAppointmentSelect(app)}
                >
                  <div className="appointment-date">{app.date}</div>
                  <div
                    style={{
                      color:
                        selectedAppointment?.id === app.id && theme === "dark"
                          ? "#3b82f6"
                          : selectedAppointment?.id === app.id &&
                            theme === "light"
                          ? "#3b82f6"
                          : "",
                    }}
                    className="appointment-time"
                  >
                    {app.time}
                  </div>
                  <div className="appointment-badge">Disponible</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Resto del código permanece igual */}
        <div className="calendar-container card_background mt-4">
          <div
            style={{
              backgroundColor: theme === "dark" ? "#171717" : "#f9fafb",
            }}
            className="calendar-column"
          >
            <h4 className="title">Selecciona una fecha</h4>
            <DayPicker
              mode="single"
              selected={selectedDate}
              onSelect={onDateSelect}
              fromDate={new Date()}
              locale="es"
              weekStartsOn={1}
              styles={{
                root: { fontSize: "14px" },
                head_cell: {
                  fontSize: "10px",
                  padding: "2px 0",
                },
                button: { fontSize: "12px" },
                day: {
                  width: "20px",
                  height: "20px",
                  fontSize: "13px",
                  padding: "0",
                },
                caption_label: { fontSize: "12px" },
                nav_button: {
                  width: "10px",
                  height: "10px",
                },
              }}
              modifiersClassNames={{
                selected: "rdp-selected",
                today: "rdp-today",
              }}
              footer={
                selectedDate ? (
                  <p
                    style={{ color: theme === "dark" && "#c3cbe4" }}
                    className="selected-day"
                  >
                    Día seleccionado:{" "}
                    <strong>
                      {moment(selectedDate).format("dddd D [de] MMMM")}
                    </strong>
                  </p>
                ) : (
                  <p className="selected-day">Selecciona una fecha</p>
                )
              }
            />
          </div>

          <div style={{ display: "grid", gap: "1rem" }}>
            {selectedDate && (
              <div
                className="available-hours-section"
                style={{
                  backgroundColor: theme === "dark" ? "#171717" : "#f9fafb",
                }}
              >
                <div className="section-header">
                  <h4 className="title">Horarios Disponibles</h4>
                  <div
                    className={`${
                      theme === "dark" ? "date-display-dark" : "date-display"
                    }`}
                  >
                    {selectedDate.toLocaleDateString("es-ES", {
                      weekday: "long",
                      day: "numeric",
                      month: "long",
                    })}
                  </div>
                </div>
                {selectedDate ? (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {renderAvailableHours()}
                  </div>
                ) : (
                  <p>Primero elige una fecha.</p>
                )}
              </div>
            )}
            {selectedTime && (
              <div className="next-step-container">
                <button className="next-btn" onClick={onNextStep}>
                  <span>Siguiente</span>
                  <span style={{marginRight:"-.5rem"}}>
                    <TbChevronRight size={21} />
                  </span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentStep;
